import React from "react";
import { useHistory } from "react-router";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const BotonSalirLimpiarStorageUsuario = () => {
  const navigate = useHistory();

  const handleSalirLimpiar = () => {
    window.localStorage.removeItem("idUsuarioStorage");
    navigate.push("/initialHome");
  };

  return (
    <div className="closeButton-container">
      <IconButton
        arial-label="cerrar"
        size="large"
        onClick={() => {
          handleSalirLimpiar();
        }}
      >
        <CloseIcon fontSize="large" />
      </IconButton>
    </div>
  );
};

export default BotonSalirLimpiarStorageUsuario;
